


import * as moment from 'moment';

export interface CheckRequirementsFormValue {
    userId?: string;
    countryId?: number;
    from: string;
    to: string;
}

export const getCheckRequirementsFormInitialValue = () => {
    return {
        userId: null,
        countryId: null,
        from: moment().startOf('day').toISOString(),
        to: moment().add(10, 'days').toISOString()
    } as CheckRequirementsFormValue;
};
